import { render } from "./RemittanceDetails.vue?vue&type=template&id=07326501&scoped=true"
import script from "./RemittanceDetails.vue?vue&type=script&lang=js"
export * from "./RemittanceDetails.vue?vue&type=script&lang=js"

import "./RemittanceDetails.vue?vue&type=style&index=0&id=07326501&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07326501"]])

export default __exports__